import { PaginationButtons } from './components';
import { CardValue } from './components/CardValue';
import {
  CardTitle,
  Container,
  Footer,
  TableContainer,
  TitleContainer,
} from './styles';

interface ITable {
  title: string;
  heads: (string | JSX.Element)[];
  children?: JSX.Element[] | JSX.Element;
  hasPagination: boolean;
  itemsPerPage?: number;
  setItemsPerPage?: React.Dispatch<React.SetStateAction<number>>;
  page?: number;
  setPage?: React.Dispatch<React.SetStateAction<number>>;
  totalItems?: number;
  // quando informado, decide o botão "próxima" no lugar da heurística por totalItems
  hasNextPage?: boolean;
  showCardValue?: boolean;
  titleValue?: string;
  valueCardValue?: number;
  itemsPerPageOptions?: number[];
}

export const DataTable: React.FC<ITable> = ({
  title,
  heads,
  children,
  hasPagination,
  itemsPerPage,
  setItemsPerPage,
  page,
  setPage,
  totalItems,
  hasNextPage,
  showCardValue = false,
  titleValue,
  valueCardValue,
  itemsPerPageOptions = [10, 25, 50, 100]
}) => (
  <div>
    <Container>
      <TitleContainer>
        <CardTitle>
          <h2>{title}</h2>
          {showCardValue && (
            <CardValue titleValue={titleValue} value={valueCardValue} />
          )}
        </CardTitle>
      </TitleContainer>

      <TableContainer>
        <table>
          <thead>
            <tr>
              {heads.map((head, index) => (
                <th key={index}>
                  <div>{head}</div>
                </th>
              ))}
            </tr>
          </thead>
          {children}
        </table>
      </TableContainer>
    </Container>
    {hasPagination && (
      <Footer>
        <PaginationButtons
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          page={page}
          setPage={setPage}
          totalItems={totalItems}
          hasNextPage={hasNextPage}
          itemsPerPageOptions={itemsPerPageOptions}
        />
      </Footer>
    )}
  </div>
);
